module.exports = __webpack_public_path__ + "img/buyBanner.8e917907.png";